module.exports = __webpack_public_path__ + "img/card-colaboradores.3acbe229.svg";